// 常用 emoji 分组（轻量内置选择器用）
export const EMOJI_GROUPS = [
  {
    name: '表情',
    list: ['😀','😁','😂','🤣','😊','😍','😘','😎','🤔','😐','😏','😢','😭','😤','😠','🥺','😴','🤯','😱','🤗','🙄','😇','🤤','😋'],
  },
  {
    name: '手势',
    list: ['👍','👎','👌','✌️','🤝','👏','🙌','🙏','💪','👀','🤙','✋','👋','🤞','💯','🔥','✨','⭐','🎉','❤️','💔','💬'],
  },
  {
    name: '物件',
    list: ['💡','📌','📎','✅','❌','⚠️','❓','❗','🚀','🎯','📈','📉','🍺','☕','🍜','🎮','💻','📱','🐶','🐱','🌈','🌙'],
  },
]
